import { PluginType, EventType, } from '@segment/analytics-react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { CookieAwareEnrichmentPlugin } from './CookieAwareEnrichmentPlugin';
const NINETY_DAYS_IN_MS = (90 * 24 * 60 * 60 * 1000);
export class GoogleAnalyticsEnrichmentPlugin extends CookieAwareEnrichmentPlugin {
    type = PluginType.enrichment;
    async execute(event) {
        if (!this.isWeb) {
            return event;
        }
        try {
            const data = await this.getTrackingData();
            const isValidEventType = event.type === EventType.TrackEvent
                || event.type === EventType.ScreenEvent;
            if (isValidEventType && data) {
                event.context.clientIds = {
                    ...event.context.clientIds,
                    ...data,
                };
            }
        }
        catch (err) {
            console.error('Error in GoogleAnalyticsEnrichmentPlugin', err);
        }
        return event;
    }
    async getTrackingData() {
        if (!this.isWeb)
            return {};
        const data = await this.getStandardGAProperties();
        const gclid = await this.getGclidFromUrlParams();
        if (gclid) {
            data['gclid'] = gclid;
            return data;
        }
        const storedGclid = await this.getStoredGclid();
        if (storedGclid) {
            data['gclid'] = storedGclid;
            return data;
        }
        return data;
    }
    async getStoredGclid() {
        const data = await AsyncStorage.getItem('_gclid');
        if (!data) {
            return undefined;
        }
        let parsed = undefined;
        try {
            parsed = JSON.parse(data);
        }
        catch (err) {
            return undefined;
        }
        if (parsed && parsed?.exp >= Date.now()) {
            return parsed.value;
        }
        else if (parsed && parsed?.exp < Date.now()) {
            await this.removeStoredGclid();
        }
        return undefined;
    }
    async setStoredGclid(value) {
        const data = {
            value,
            exp: (new Date(Date.now() + NINETY_DAYS_IN_MS)).getTime(),
        };
        await AsyncStorage.setItem('_gclid', JSON.stringify(data));
    }
    async removeStoredGclid() {
        try {
            await AsyncStorage.removeItem('_gclid');
        }
        catch (err) {
            return;
        }
    }
    async getGclidFromUrlParams() {
        const parsed = new URL(window.location.href);
        const gclid = parsed.searchParams.get('gclid');
        const gclsrc = parsed.searchParams.get('gclsrc');
        const isGclsrcValid = !gclsrc || gclsrc.indexOf('aw') !== -1;
        if (gclid && isGclsrcValid) {
            await this.setStoredGclid(gclid);
        }
        return gclid || undefined;
    }
    async getStandardGAProperties() {
        const payload = {};
        const cookies = await this.getCookiesWithPrefix('_ga');
        const ga = cookies['_ga'];
        if (ga) {
            const parsed = ga.split('.');
            payload.ga4 = payload.ga4 || {};
            payload.ga4.clientId = `${parsed.at(-2)}.${parsed.at(-1)}`;
        }
        delete cookies['_ga'];
        const additionalKeys = Object.keys(cookies);
        if (additionalKeys.length > 0) {
            payload.ga4 = payload.ga4 || {};
            payload.ga4.sessionIds = {};
            for (const key of additionalKeys) {
                const sessionId = cookies[key]?.split('.')?.[2];
                const parsedSessionId = parseInt(sessionId, 10) || undefined;
                const formattedKey = key.replace(/^_ga_/, '');
                if (parsedSessionId) {
                    payload.ga4.sessionIds[formattedKey] = parsedSessionId;
                }
            }
        }
        return payload;
    }
}
//# sourceMappingURL=GoogleAnalyticsEnrichmentPlugin.js.map